<template>
  <div class="chartContentWrapper">
    <div class="header">
      <div class="headerTitleCountWrapper">
        <span class="title">{{title}}</span>
        <span class="count">{{count}}</span>
      </div>
      <div class="headerComparisonWrapper" v-if="percentAvailable">
        <span class="chartPercentTitle">전주대비</span>
        <img class="arrow" v-bind:src="arrow">
        <span class="chartPercentValue" v-bind:style="style.arrowDirection">{{percentValue + '%'}}</span>
      </div>
    </div>
<!--    각 차트의 y축 고정 겹칩 문제때문에 class명을 나눔-->
    <div class="chartAreaWrapper1" v-if="this.chartType === 'exposedCnt'">
      <div class="chartArea1" ref="chartArea">
        <exposed-bar-chart v-bind:chartData="dataCollection" v-bind:style="style.chartStyle"></exposed-bar-chart>
      </div>
      <canvas id="axis-Test1" height="254" width="0"></canvas>
    </div>
    <div class="chartAreaWrapper2" v-if="this.chartType === 'answeredCnt'">
      <div class="chartArea2" ref="chartArea">
        <answered-bar-chart v-bind:chartData="dataCollection" v-bind:style="style.chartStyle"></answered-bar-chart>
      </div>
      <canvas id="axis-Test2" height="254" width="0"></canvas>
    </div>
    <div class="chartAreaWrapper3" v-if="this.chartType === 'adFee'">
      <div class="chartArea3" ref="chartArea">
        <ad-fee-bar-chart v-bind:chartData="dataCollection" v-bind:style="style.chartStyle"></ad-fee-bar-chart>
      </div>
      <canvas id="axis-Test3" height="254" width="0"></canvas>
    </div>
    <div class="chartFooterWrapper" v-if="this.chartType === 'exposedCnt' || this.chartType === 'answeredCnt'">
      <div>
        <img v-bind:src="require('@/assets/img/bar_chart_blue_label.png')">
        <span>남성</span>
      </div>
      <div>
        <img v-bind:src="require('@/assets/img/bar_chart_yellow_label.png')">
        <span>여성</span>
      </div>
      <div>
        <img v-bind:src="require('@/assets/img/bar_chart_grey_label.png')">
        <span>성별모름</span>
      </div>
    </div>
  </div>
</template>

<script>
import exposedBarChart from './exposedBarChart'
import answeredBarChart from './answeredBarChart'
import adFeeBarChart from './adFeeBarChart'

export default {
  components: {
    'exposed-bar-chart': exposedBarChart,
    'answered-bar-chart': answeredBarChart,
    'ad-fee-bar-chart': adFeeBarChart
  },
  props: {
    title: String,
    count: String,
    percentAvailable: Boolean,
    isArrowUp: Boolean,
    percentValue: Number,
    chartType: String,
    chartData: Object
  },
  data () {
    return {
      arrow: '',
      style: {
        arrowDirection: '',
        chartStyle: ''
      },
      // eslint-disable-next-line no-new-object
      dataCollection: new Object()
    }
  },
  methods: {
    scrollToLeft: async function () {
      let container = this.$refs.chartArea
      // 차트가 다 그려질때까지 sleep
      await this.sleep(250)
      container.scrollLeft = container.scrollWidth
    },
    sleep: function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    setArrowProperties: function () {
      this.arrow = this.isArrowUp ? require('@/assets/img/chart_up_arrow.png') : require('@/assets/img/chart_down_arrow.png')
      this.style.arrowDirection = this.isArrowUp ? 'color: rgb(13,196,0); ' : 'color: rgb(255,70,0); '
    }
  },
  created: function () {
    this.setArrowProperties()
  },
  mounted: function () {
    this.style.chartStyle += 'width: 1000px; height: 254px;'
    this.scrollToLeft()
  },
  watch: {
    chartData: {
      deep: true,
      handler: function () {
        this.dataCollection = this.chartData
      }
    },
    isArrowUp: function () {
      this.setArrowProperties()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  height: 100%;
  width: auto;
}

.chartContentWrapper {
  display: inline-block;
  width: 254px;
  margin: 0 20px;
}

.header {
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.headerTitleCountWrapper {
  width: 145px;
}

.headerTitleCountWrapper > .title{
  font-size: 14px;
}

.headerTitleCountWrapper > .count{
  font-size: 20px;
  font-weight: bold;
}

.headerComparisonWrapper {
  display: inline-flex;
  justify-content:left;
  align-items: flex-end;
  margin: 0;
  padding: 0;
}

.headerComparisonWrapper > .chartPercentTitle {
  font-size: 10px;
}

.headerComparisonWrapper > .arrow{
  width: 16px;
  height: 16px;
}

.headerComparisonWrapper > .chartPercentValue{
  font-size: 14px;
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  list-style: none;
}

.navItem {
  margin-right: 12%;
}

.navButton {
  background-color: transparent;
  outline: none;
  border: none;
  margin: 0;
  padding: 0 0 5px 0;
  text-align: left;
  font-size: 16px;
  border-bottom: transparent 3px solid;
}

.navButton.active, .navButton:hover{
  border-bottom-color: rgb(6,221,255);
}

.chartAreaWrapper1 {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-end;
}

.chartAreaWrapper1 > canvas {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.chartAreaWrapper1 > .chartArea1 {
  width: 224px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  overflow-x: scroll;
}

.chartAreaWrapper1 > .chartArea1::-webkit-scrollbar {
  height: 10px;
}
.chartAreaWrapper1 > .chartArea1::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.chartAreaWrapper1 > .chartArea1::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}

.chartFooterWrapper {
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  height: 40px;
  justify-content: center;
}

.chartFooterWrapper > div {
  font-size: 10px;
  padding: 0 12px;
}

.chartFooterWrapper > div > img {
  width: 16px;
  height: 4px;
}

.chartAreaWrapper2 {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-end;
}

.chartAreaWrapper2 > canvas {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.chartAreaWrapper2 > .chartArea2 {
  width: 224px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  overflow-x: scroll;
}

.chartAreaWrapper2 > .chartArea2::-webkit-scrollbar {
  height: 10px;
}
.chartAreaWrapper2 > .chartArea2::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.chartAreaWrapper2 > .chartArea2::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}

.chartAreaWrapper3 {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-end;
}

.chartAreaWrapper3 > canvas {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
}

.chartAreaWrapper3 > .chartArea3 {
  width: 224px;
  padding-bottom: 15px;
  margin-bottom: 10px;
  overflow-x: scroll;
}

.chartAreaWrapper3 > .chartArea3::-webkit-scrollbar {
  height: 10px;
}
.chartAreaWrapper3 > .chartArea3::-webkit-scrollbar-thumb {
  background-color: #000000;
}
.chartAreaWrapper3 > .chartArea3::-webkit-scrollbar-track {
  background-color: #EFEFEF;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/mainBoardchart.vue